module.exports = __webpack_public_path__ + "static/image1-102fd2d8e11a6314b687dfc992ebfdde.png";